<template>
  <div id="app" ref="app">
    <!-- <keep-alive>
      <router-view />
    </keep-alive> -->
    <keep-alive exclude="canvas-bg">
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view :audioStatus="audioPaused" v-if="!$route.meta.keepAlive"></router-view>
    <!-- 全局音频dom元素 start -->
    <div class="audio_box" ref="audio_box" v-if="isShowAudio" @touchstart="touchStart" @touchmove.prevent="touchMove" @touchend.prevent="touchEnd">
      <div class="audio_position">
        <div class="audio_content">
          <div class="audio_icon">
            <van-circle v-model="currentRate" :rate="targetRate" :speed="100" stroke-width="80" color="#00C76E" layer-color="#F2F2F2" :text="'text'" size="34px">
              <div class="audio_play_box" slot="default">
                <img :src="audioPaused?require('./assets/img/audioEnd_icon.png'):require('./assets/img/audioPlay_icon.png')" alt="">
              </div>
            </van-circle>
          </div>
          <div class="audio_text">
            <div class="audio_title">{{audioTitle}}</div>
            <div class="audio_current">{{currentTime}}&nbsp;/&nbsp;{{allTime}}</div>
          </div>
          <div class="audio_checkout" :style="{visibility:audioWoMan && audioMan?'':'hidden'}" @click="checkoutAudio">
            <span>切换</span>
          </div>
        </div>
        <img class="close_icon" src="./assets/img/audio_close_icon.png" alt="">
      </div>
      <audio ref="audio" :src="isMan?audioMan?audioMan:audioWoMan:audioWoMan" @ended="audioEnded" @canplay="audioCanplay" @pause="audioPause" @play="audioPlay" v-show="false"></audio>
    </div>
    <!-- 全局音频dom元素 end -->

  </div>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {
      // audio start
      // 总进度
      currentRate: 0,
      // 当前进度
      targetRate: 0,
      // 男声
      audioMan: '',
      // 女声
      audioWoMan: '',
      // 音频标题
      audioTitle: '当你看到的时候就意味着你的标题写的有问题',
      // 是否女生播放语音
      isMan: true,
      // 是否显示
      isShowAudio: false,
      // 当前时间
      currentTime: '00:00',
      // 总时间
      allTime: '00:00',
      // 进度时间intver
      audioIntvel: null,
      // audio end

      // 元素拖拽
      // 鼠标据拖拽元素的相对位置
      relativeX: 0,
      relativeY: 0,
      audioPaused: false,
      // 音频是否在播放
      audioStatus: false,
    };
  },
  mounted() {
    document.getElementById('app').onscroll = () => {
      if (this.$refs['audio_box']) {
        this.deformation();
      }
    }
  },
  methods: {

    /**
     * audio 暂停播放 监听
     */
    audioPause() {
      this.audioStatus = false;
    },

    /**
     * audio 开始播放 事件
     */

    audioPlay() {
      this.audioStatus = true;
    },


    /**
     * 暂停或播放
     */
    playOrPause() {
      this.audioPaused = this.$refs.audio.paused;
      if (this.$refs.audio.paused) {
        this.$refs.audio.play();
        this.audioStatus = true;
      } else {
        this.$refs.audio.pause();
        this.audioStatus = false;
      }
    },

    /**
     * 手指触摸事件
     */
    touchStart(event) {
      // 鼠标相对audio_box的相对位置
      this.relativeX = event.touches[0].clientX - this.$refs['audio_box'].offsetLeft;
      this.relativeY = event.touches[0].clientY - this.$refs['audio_box'].offsetTop;
      // console.log(event.target,'target');
      console.dir(event.target);

      /**
       * 因阻止默认事件 故使用此方式绑定事件
       */
      // 点击到播放/暂停
      if (event.target.nodeName == 'svg') {
        this.playOrPause();
      }
      // 点击到关闭
      if (event.target.className == 'close_icon') {
        this.stopAudio();
      }
      // 点击到切换
      if (event.target.innerText == '切换') {
        this.checkoutAudio();
      }
    },

    /**
     * 手指移动事件
     */
    touchMove(event) {
      // let offsetLeft = this.$refs['audio_box'].offsetLeft + (this.$refs['audio_box'].clientWidth / 2);
      let left = event.touches[0].clientX - this.relativeX;
      let top = event.touches[0].clientY - this.relativeY;
      let devX = 68;

      if (top < 0) { // 上区域
        top = 0;
      }
      // console.log(top,'toptoptoptoptoptoptoptop')
      // console.log(document.body.clientHeight - this.$refs['audio_box'].offsetHeight,'document.body.clientHeight')
      if (top > document.body.clientHeight - this.$refs['audio_box'].offsetHeight) { // 下区域
        top = document.body.clientHeight - this.$refs['audio_box'].offsetHeight;
      }
      if (left > (document.body.clientWidth + devX)) {  // 右区域
        left = document.body.clientWidth + devX;
      }
      if (left < this.$refs['audio_box'].clientWidth / 2) {  // 左区域
        left = this.$refs['audio_box'].clientWidth / 2;
      }

      // console.log(left, 'left');
      // console.log(offsetLeft, 'offsetLeft');
      this.$refs['audio_box'].style.left = left + 'px';
      this.$refs['audio_box'].style.top = top + 'px';
    },

    /**
     * 手指放开事件
     */
    touchEnd(event) {
      // console.log(event, 'touchEnd');
      // let audioWidth = this.$refs['audio_box'].clientWidth;
      // let offsetLeft = this.$refs['audio_box'].offsetLeft + (this.$refs['audio_box'].clientWidth / 2);
      // let offsetTop = this.$refs['audio_box'].offsetTop + (this.$refs['audio_box'].clientHeight / 2);
      // console.log(offsetTop,'offsetTop')
      // if (offsetLeft < audioWidth) {
      //   console.log('audioBox进入了左区域!!');
      // }
      // if (offsetLeft > document.body.clientWidth) {  // 进入右区域
      //   console.log('进入右区域');
      // }
      // console.log(this.$refs['audio_box'].clientWidth,"this.$refs['audio_box'].clientWidth");
      // console.log(this.$refs['audio_box'].offsetLeft,"this.$refs['audio_box'].offsetLeft");
      // console.log(document.body.clientWidth ,"document.body.clientWidth ");
      // console.log(document.body.clientWidth - this.$refs['audio_box'].clientWidth ,"document.body.clientWidth - this.$refs['audio_box'].clientWidth");
      // if((this.$refs['audio_box'].offsetLeft + this.$refs['audio_box'].clientWidth) > (document.body.clientWidth)){
      //   console.log('audioBox进入了右区域');
      // }
      // console.log(this.$refs['audio_box'].offsetTop,"this.$refs['audio_box'].offsetTop");

      // console.log(this.$refs['audio_box'].offsetRight,"this.$refs['audio_box'].offsetTop");
      // this.deformation();

    },


    /**
     * audio变形~
     */
    deformation() {
      // 偏移量
      let devX = 68;
      this.$refs['audio_box'].style.transition = 'all 0.5s ease 0s';
      this.$refs['audio_box'].style.left = (document.body.clientWidth + devX) + 'px';
      // 动画只执行一次
      setTimeout(() => {
        this.$refs['audio_box'].style.transition = '';
      }, 500)
    },
    /**
     * 播放语音
     */
    palyAudio() {
      this.isShowAudio = true;
      this.currentRate = 0;
      this.targetRate = 0;
      this.$nextTick(() => {
        this.$refs.audio.play();
        this.targetRate = this.$refs.audio.duration;
        this.audioPaused = true;
      })
    },

    /**
     * 暂停语音
     */
    pauseAudio() {
      if (this.$refs.audio) {
        this.$refs.audio.pause();
        this.audioPaused = false;
      }

    },
    /**
     * 继续语音播放
     */
    ageinAudio() {
      this.$refs.audio.play();
      this.audioPaused = false;
    },
    /**
     * 监听音频播放
     */
    audioCanplay() {
      if (this.$refs.audio) {
        this.allTime = this.getAllTime(this.$refs.audio.duration);
      }
      clearInterval(this.audioIntvel);
      this.audioIntvel = setInterval(() => {
        try {
          this.currentTime = this.getAllTime(this.$refs.audio.currentTime);
          // console.log(this.$refs.audio.duration, 'this.$refs.audio.duration')
          // console.log(this.$refs.audio.currentTime, 'this.$refs.audio.currentTime')
          this.currentRate = this.$refs.audio.currentTime;
        } catch (e) {
          console.log(e, 'eeee');
          clearInterval(this.audioIntvel);
        }
      }, 1000);
    },
    /**
     * 音频播放完毕
     */
    audioEnded() {
      clearInterval(this.audioIntvel);
      this.isShowAudio = false;
      this.audioPaused = true;
    },
    // 计算全部时间
    getAllTime(time) {
      //分钟
      var minute = time / 60;
      var minutes = parseInt(minute);
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      //秒
      var second = time % 60;
      var seconds = Math.round(second);
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      // console.log('处理音乐时长', minutes + "：" + seconds);
      return minutes + ":" + seconds;
    },
    /**
     * 停止语音播放  并重置进度
     */
    stopAudio() {
      this.$refs.audio.currentTime = 0;
      this.$refs.audio.pause();
      this.currentTime = '00:00';
      this.isShowAudio = false;
    },
    /**
     * 切换语音
     */
    checkoutAudio() {
      this.$refs.audio.currentTime = 0;
      this.$refs.audio.pause();
      this.currentTime = '00:00';
      this.isMan = !this.isMan;
      this.$nextTick(() => {
        this.palyAudio();
      })
    },
  },

}
</script>
<style lang="scss">
img,
video {
  object-fit: fill;
}
#app {
  width: 100%;
  height: 100%;
  // background: white;
  // overflow: scroll;
  // -webkit-overflow-scrolling: touch;
  // position: absolute;
  // top: 0;
  // left: 0;
  html,
  body {
    // width: 100%;
    // height: 100%;
    // margin: 0;
    // padding: 0;
    // position: relative;
  }
  .audio_box {
    position: fixed;
    left: 50%;
    bottom: 50px;
    transform: translateX(-50%);
    width: 250px;
    height: 60px;
    background: white;
    box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.15);
    border-radius: 56px 6px 33px 56px;
    z-index: 99999999;
    padding: 0 15px;
    padding-right: 20px;
    box-sizing: border-box;
    .audio_position {
      position: relative;
      .close_icon {
        position: absolute;
        top: 3px;
        right: -20px;
        width: 10px;
        height: 10px;
        padding: 5px;
      }
    }
    .audio_content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      height: 60px;
      .audio_play_box {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        img {
          width: 12px;
          height: 14px;
        }
      }
      .audio_text {
        padding-left: 10px;
        .audio_title {
          color: #000000;
          font-size: 13px;
        }
        .audio_current {
          font-size: 12px;
          color: #00ca6a;
          margin-top: 5px;
        }
      }
      .audio_checkout {
        color: rgba(0, 0, 0, 0.5);
        font-size: 12px;
        border: 1px solid rgba(0, 0, 0, 0.25);
        border-radius: 11px;
        padding: 2px 5px;
      }
    }
  }
}
</style>
